import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Button, Group, Modal, Checkbox, TextInput, Text } from '@mantine/core';

import { useEditManagerConfig } from '../api/editManagerConfig';
import { useManagerConfigForm } from '../hooks/useManagerConfigForm';
import { managerTypes } from '../types';

import { Departments } from '@/types';

type Params = {
  manager: managerTypes.Manager;
  department: Departments;
};

export const ConfigModal = NiceModal.create(({ manager, department }: Params) => {
  const modal = useModal();
  const form = useManagerConfigForm({
    initialValues: { ...manager.config, email: manager.email ?? '' },
  });

  const { mutate, isLoading } = useEditManagerConfig({
    config: { onSuccess: modal.remove },
    department,
  });

  return (
    <Modal
      centered
      overlayProps={{ opacity: 0.4, blur: 1.5 }}
      opened={modal.visible}
      onClose={() => modal.remove()}
      title={`${manager.username} information`}
    >
      <form
        onSubmit={form.onSubmit(({ email, ...config }) =>
          mutate({ managerId: manager._id, config, email: email?.trim() || undefined })
        )}
      >
        <Text my="xs" size="sm">
          Email
        </Text>
        <TextInput
          autoComplete="off"
          placeholder="Email"
          value={form.values.email}
          onChange={(event) => form.setFieldValue('email', event.currentTarget.value)}
          mb="xl"
          error={form.errors.email}
        />
        <Checkbox
          label="Show dialogs usernames"
          checked={form.values.isUsernamesVisible}
          onChange={(event) =>
            form.setFieldValue('isUsernamesVisible', event.currentTarget.checked)
          }
          size="md"
          variant="outline"
          my="xl"
        />
        <Checkbox
          label="Show system messages"
          checked={form.values.isSystemMessagesVisible}
          onChange={(event) =>
            form.setFieldValue('isSystemMessagesVisible', event.currentTarget.checked)
          }
          size="md"
          variant="outline"
          my="xl"
        />
        <Checkbox
          label="Enable messages translation"
          checked={form.values.isMessagesTranslationEnabled}
          onChange={(event) =>
            form.setFieldValue('isMessagesTranslationEnabled', event.currentTarget.checked)
          }
          size="md"
          variant="outline"
          my="xl"
        />
        <Group justify="right">
          <Button loading={isLoading} type="submit">
            Save
          </Button>
        </Group>
      </form>
    </Modal>
  );
});
